import React from 'react';
//CSS
import styles from './ProgressStatusBadge.module.css';
//Components
//Data

type ProgressStatusBadgeProps = {
    status: 'inProgress' | 'completed' | 'notStarted' | 'notMet' | "exceeded";
    text: string;
    style?: React.CSSProperties;
    notSetText?: string;
};

const ProgressStatusBadge = ({ status, text, style, notSetText } : ProgressStatusBadgeProps) => {
  return (
    <div className={`${styles.container} ${styles[status]}`} style={style}>
      {text === "" || text === undefined ? (notSetText ?? "Status not set") : text}
    </div>
  );
};

export default ProgressStatusBadge;